/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    import Block = Models.Block;
    import ITSProbeInfo = Application.Models.ITSProbeInfo;
    import DeviceParam = Application.Models.DeviceParam;
    import Utils = Common.Utils;
    import IBlock = Application.Models.IBlock;
    import RedundantBlocks = Application.Models.RedundantBlocks;
    import IStreamPipe = Application.Models.IStreamPipe;
    import StreamPipe = Application.Models.StreamPipe;
    import NetworkNodeType = Application.Models.NetworkNodeType;
    import INetworkInterface = Application.Models.INetworkInterface;
    import BlockTypeNaturalKey = Application.Models.BlockTypeNaturalKey;

    interface IMapStreamAliveDataOptions {
        [key: string]: {
            label: string;
            value: number;
        };
    }

    interface IMapedStreamAliveDataOption {
        key: string;
        label: string;
        value: number;
    }

    export interface IEncoderOptions {
        encoderInput?: string;
        audioInput?: string;
        encoderOutput?: string;
        delay?: string;
        codec?: string;
        audioCodec?: string;
    }

    export interface IDigestedInfo { [param: string]: string | number | boolean; }

    export interface IBlockInfo {
        name?: string;
        blockConnection?: Models.IStreamPipeBlockConnectionInfo;
        guiUrl?: string;
        adminUrl?: string;
        parsedInfo?: Models.IDeviceParams;
        firstParsedDatetime?: number;
        lastParsedDatetime?: number;
        lastParseTimeDiff?: string;
        deviceUnreachable: boolean;
        blockIndex?: string;
        isIO?: boolean;
        last200?: Date;
        nodeType?: Models.NetworkNodeType;
    }

    /**
     * StreamDetailsController class
     */
    export class StreamDetailsController {
        public static $name: string = 'streamDetailsController';
        public static $inject: string[] = ['$scope',
            'connectionRoomService',
            'presetPathService',
            '$timeout',
            '$interval',
            '$routeParams',
            'streamStatusService',
            'streamPipeService',
            'deviceGuiService',
            '$sce',
            'timezoneService',
            '$location',
            '$cookies',
            'videoFeedService',
            'userService',
            'networkNodeTypeService',
            'flexCollectorService',
            'tsProbeService',
            'messageTranslationsService',
            'aclService',
            '$rootScope',
            '$q',
            '$window',
            'blockService',
            'ModalService',
            'networkNodeService'
        ];

        public static COOKIE_OPTIONS: ng.cookies.ICookiesOptions =
            { expires: Utils.getCookieExpirationDate(), secure: location.protocol === 'https:' };
        public static COOKIE_THRESHOLD_VALUE_KEY: string = 'flex_threshold_value_stream_';
        public static COOKIE_THRESHOLD_ENABLED_KEY: string = 'flex_threshold_enabled_stream_';
        public static IO_NETWORK_NODE_TYPE_ID: string = '3';

        private static STREAM_DATA_TIMER: number = 5000;
        private static INTERFACE_PARSER_TIMER: number = 5000;
        private static INTERFACE_PARSER_ELAPSED_TIMER: number = 2500;
        private static AUDIO_PROBING_TIMER: number = 1000;

        public sourceAudios: Models.FullAudioInfo[] = [];
        public sinkAudios: Models.FullAudioInfo[] = [];
        public vuMeterAudio: Models.FullAudioInfo[] = [];
        public txInfo: boolean = true;
        public loadingIframe: boolean = true;
        public isAlreadyMonitored: boolean;

        public allProbes: ISelectableProbe[] = [];
        public selectedProbes: ISelectableProbe[] = [];

        private streamExists: boolean = false;
        private streamURL: string;
        private streamTimer: ng.IPromise<void>;
        private getDataTimer: ng.IPromise<void>;
        private dataStatus: Models.IStreamStatus;
        private streamPipe: Models.IStreamPipe;
        private videoFeed: Models.IVideoFeed;
        private streamId: number;
        private streamRedundantId: number;
        private blocksInfo: IBlockInfo[];
        private redundantBlocksInfo: IBlockInfo[];
        private sourceInfo: IDigestedInfo;
        private sourceNodeInfo: IDigestedInfo;
        private sinkInfo: IDigestedInfo;
        private sinkNodeInfo: IDigestedInfo;
        private encoderOptions: IEncoderOptions;
        private processAdminInterfacesInterval: ng.IPromise<{}>;
        private timeDiffInterval: ng.IPromise<{}>;
        private currentBitrateMbps: number;
        private userIsAdmin: boolean;
        private canReadSupport: boolean;
        private sourceProbeInfo: ITSProbeInfo;
        private sinkProbeInfo: ITSProbeInfo;
        private isSourceTs: boolean;
        private isSinkTs: boolean;
        private skipRequests: number = 0;
        private streamPipeRedundant: IStreamPipe[];
        private streamPipeSourceBlock: IBlock;

        private audioMonitoringEnabled: boolean = false;
        private showRedundantStream: boolean = false;

        private maxSynthValues: number;
        private numSynthValues: number;
        private trendingInfo: Models.TrendingInfo;

        private reRender: boolean = true;
        private urlParameters: string;
        private presetPathOriginValue: string;
        private presetPathDestinationValue: string;
        private stompReconnectUnsubscribe: Function;
        public matrixRoom: Models.MatrixRoom;

        public devicesIdsNodesEnum: any = {
            MVP_AGILE: 7,
            MVP_O4: 5,
            MVP_O2: 4,
            MVP_IO: 3,
        }

        private pipeElements: Models.IStreamPipeElement[];
        calculated = false
        grafanaUrlObtained = false
        grafanaUrl = ""

        /**
         * Constructor of the class.
         */
        constructor(private $scope: ng.IScope,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private presetPathService: Services.PresetPathService,
                    private $timeout: ng.ITimeoutService,
                    private $interval: ng.IIntervalService,
                    private $routeParams: ng.route.IRouteParamsService,
                    private streamStatusService: Services.StreamStatusService,
                    private streamPipeService: Services.StreamPipeService,
                    private deviceGuiService: Services.DeviceGuiService,
                    private $sce: ng.ISCEService,
                    private timezoneService: Services.TimezoneService,
                    private $location: ng.ILocationService,
                    private $cookies: ng.cookies.ICookiesService,
                    private videoFeedService: Services.VideoFeedService,
                    private userService: Services.UserService,
                    private networkNodeTypeService: Application.Services.NetworkNodeTypeService,
                    private flexCollectorService: Services.FlexCollectorService,
                    private tsProbeService: Services.TsProbeService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private aclService: Services.AclService,
                    private $rootScope: Services.IFlexSettings,
                    private $q: ng.IQService,
                    private $window: ng.IWindowService,
                    private blockService: Services.BlockService,
                    private modalService: ngModal.IModalService,
                    private networkNodeService: Services.NetworkNodeService,
                    ) {

            this.initVariables();
            this.initBindings();
            this.getStreamIdAndStreamBlocksInfo();
            this.initTrending();

            if (document.getElementById('guiIframe')) {
                document.getElementById('guiIframe').onload = () => {
                    this.loadingIframe = false;
                };
            }

            $rootScope.$on('timezoneChanged', () => {
                this.reRender = false;
                if (this.trendingInfo) {
                    this.trendingInfo.close();
                    this.trendingInfo = undefined;
                }

                this.initTrending();
                $timeout(() => this.reRender = true, 0);

            });

            this.streamPipeService
            .getStreamPipeViewByStreamId(this.streamId)
            .then((pipeElements: Models.IStreamPipeElement[]) => {
              this.pipeElements = pipeElements;
              const match = pipeElements.some((element: Models.IStreamPipeElement) => {
                return this.isVirtSrtRxCall(element) || this.isVirtSrtTxCall(element) || this.isVirtSrtRxLstn(element) || this.isVirtSrtTxLstn(element);
              })
              if (match) {
                const filtered=pipeElements.filter((element: Models.IStreamPipeElement) => {
                    return element.blockI.blockTypeNaturalKey.indexOf('SRT_GW_')    > -1;
                });
                if (filtered.length==1) {
                    this.streamPipeService.getGrafanaUrl(filtered[0]).then((url: string) => {
                        this.grafanaUrl = url;
                        this.grafanaUrlObtained = true;
                        this.calculated = true;
                      });
                } else {
                    this.calculated = true;
                }
                  
              } else {
                this.calculated = true;
              }
              
            });
        }


        public isVirtSrtRxCall(iStreamPipeElement: Models.IStreamPipeElement): boolean {
            return (
              iStreamPipeElement.blockI.blockTypeNaturalKey ===
              BlockTypeNaturalKey.VIRT_SRT_RX_CALL
            );
          }
          public isVirtSrtTxCall(iStreamPipeElement: Models.IStreamPipeElement): boolean {
            return (
              iStreamPipeElement.blockI.blockTypeNaturalKey ===
              BlockTypeNaturalKey.VIRT_SRT_TX_CALL
            );
          }
      
      
          public isVirtSrtRxLstn(iStreamPipeElement: Models.IStreamPipeElement): boolean {
            return (
              iStreamPipeElement.blockI.blockTypeNaturalKey ===
              BlockTypeNaturalKey.VIRT_SRT_RX_LSTN
            );
          }
          public isVirtSrtTxLstn(iStreamPipeElement: Models.IStreamPipeElement): boolean {
            return (
              iStreamPipeElement.blockI.blockTypeNaturalKey ===
              BlockTypeNaturalKey.VIRT_SRT_TX_LSTN
            );
          }
        
        public showHistoricalTraffic(): void {
            this.$location.path('/historical/' + this.streamId);
        }

        public switchTxinfo(value: boolean): void {
            this.txInfo = value;
        }

        public onVideoPlayAttempt(): void {
            this.videoFeedService.notifyVideoPlayAttemptByStreamPipeId(this.streamId, this.videoFeed);
        }

        public onVideoPlayError(): void {
            this.videoFeedService.notifyVideoPlayErrorByStreamPipeId(this.streamId, this.videoFeed);
        }

        public openAdminSettings(block: number): void {
            if (this.blocksInfo[block] !== undefined && this.blocksInfo[block].adminUrl !== undefined) {
                let deviceGui: Models.DeviceGui = new Models.DeviceGui();
                deviceGui.guiUrl = this.blocksInfo[block].adminUrl.toString();
                deviceGui.proxyType = this.$rootScope.backendConfig.flexoProxyType;
                if (block === 0) {
                    this.deviceGuiService.notifyAdminSettingsAttempt(this.streamPipe.sourceNodeHref, deviceGui);
                } else {
                    this.deviceGuiService.notifyAdminSettingsAttempt(this.streamPipe.sinkNodeHref, deviceGui);
                }
                window.open(this.blocksInfo[block].adminUrl, '_blank');
            } else {
                this.messageTranslationsService.alertOnError('Something was wrong: device unreachable.', 'bottom-center');
            }
        }

        // TODO: avoid calling method from HTML
        public supportUrlPath(block: number): string {
            if (!this.blocksInfo || !this.blocksInfo[block] || !this.blocksInfo[block].blockConnection)
                return;

            if (block === 0) {
                return "/" + this.blocksInfo[block].blockConnection.origBlock.networkNodeHref;
            } else {
                return "/" + this.blocksInfo[block].blockConnection.destBlock.networkNodeHref;
            }
        }

        public isStreamingNow(side: 'source' | 'sink'): boolean {
            if (side === 'source') {
                return (this.getSourceParam('streamStatus') as boolean);
            } else {
                return (this.getSinkParam('streamStatus') as boolean);
            }
        }

        public getSourceParam(param: string): string | number | boolean {
            if (this.sourceInfo) {
                if (param === 'detectedFormat') {
                    return this.sourceInfo[param] ? this.sourceInfo[param] : '  ' ;
                }

                else if (param === 'audioLevel') {
                    let sourceAudioLevel: number = this.getSourceAudioLevel(3);
                    let channel34String: string = sourceAudioLevel ? ` | ${sourceAudioLevel} | ${this.getSourceAudioLevel(4)}` : "";
                    return `${this.getSourceAudioLevel(1)} | ${this.getSourceAudioLevel(2)}` + channel34String;
                } else if (param === 'srtUrlIp') {
                    if (this.sourceInfo['srtHost']) {
                        return this.sourceInfo['srtHost'];
                    } else {
                        let urlParams =  this.sourceInfo['srtUrl'].toString().split(":");
                        let ip = urlParams[1].substring(2);
                        return ip;
                    }
                } else if (param === 'srtUrlPort') {
                    if (this.sourceInfo['srtPort']) {
                        return this.sourceInfo['srtPort'];
                    } else {
                        return Utils.getUrlParam(this.sourceInfo["srtUrl"].toString(), "port");
                    }
                } else if (param === 'srtUrlPassphrase') {
                    if (this.sourceInfo['srtPassphrase']) {
                        return this.sourceInfo['srtPassphrase'];
                    } else {
                        return Utils.getUrlParam(this.sourceInfo["srtUrl"].toString(), "passphrase");
                    }
                } else if (param === 'srtUrlMode') {
                    if (this.sourceInfo['srtMode']) {
                        return this.sourceInfo['srtMode'];
                    } else {
                        return Utils.getUrlParam(this.sourceInfo["srtUrl"].toString(), "mode");
                    }
                } else {
                    return this.sourceInfo[param];
                }
            }
        }

        public getSourceVideoInfo(): string {
            if (!this.sourceInfo)
                return '';

            let codec: string = this.getSourceParam('video.codec') as string;
            if ((codec === undefined || codec === '') && this.encoderOptions !== undefined) {
                codec = this.encoderOptions.codec;
            }

            const bitrate: number = this.getSourceParam('configuredBitrate') as number;

            const delay: string = this.encoderOptions !== undefined ? this.encoderOptions.delay : undefined;

            const pid: string = this.getSourceParam('video.pid') as string;

            let videoInfo: string = '';
            videoInfo += !!codec ? codec : 'H264';
            videoInfo += !!bitrate ? `, ${(bitrate / 1000000).toFixed(2)} Mbps` : '';
            videoInfo += !!delay ? `, ${delay}` : '';
            videoInfo += !!pid ? ` - PID ${pid}` : '';

            return videoInfo + '  ';
        }

        /**
         * 
         * @param isPresetPath origin or destination has a preset path? 
         * @param retakeOrigin encoder or decoder part from stream details
         */
        public reTake(isPresetPath: any, retakeOrigin: string): void {
            if(this.blocksInfo[this.blocksInfo.length-1].blockConnection.destBlock.locked) {
                this.reTakeNotAllowed();
            }
            else {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.RetakeController.templateURL,
                    controller: Application.Controllers.RetakeController.$name,
                    inputs: {
                        blocksInfo: this.blocksInfo,
                        isPresetPath: isPresetPath,
                        retakeOrigin: retakeOrigin
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.RetakeController.ID,
                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then(() => {
                        modalElem.hide();
                    });
                });
            }

        }

        public reTakeNotAllowed(): void {
            this.modalService.showModal({
                templateUrl: Controllers.InfoModalController.templateURL,
                controller: Controllers.InfoModalController.$name,
                inputs: {
                    title: 'Retake not Available',
                    description: 'Device locked. Please unlock the device first',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                });
            });
        }


        public monitorProbe(): void {
            const srtUrl = this.getSinkParam('srtUrl');

            this.modalService.showModal({
                templateUrl: Application.Controllers.MonitorProbeController.templateURL,
                controller: Application.Controllers.MonitorProbeController.$name,
                inputs: {
                    blocksInfo: this.blocksInfo,
                    srtUrl: srtUrl
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.MonitorProbeController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    this.isMonitored();
                    modalElem.hide();
                });
            });
        }

        public async monitorRtspUrl(): Promise<void> {
            let sinkNode = await this.blockService.getNodeFromBlockId(this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlockId);
            let sourceNode = await this.blockService.getNodeFromBlockId(this.blocksInfo[0].blockConnection.origBlockId);
            console.log(JSON.stringify(sinkNode));
            let ip = sinkNode.networkInterfaces.filter( (networkInterface: INetworkInterface) => networkInterface.name === "STREAM" )[0].ipAddress;
            let rtspUrl = "rtsp://" + ip + ":554/playout-" + sourceNode.mftSerialNumber + "-1.sdp";
            this.modalService.showModal({
                templateUrl: Application.Controllers.MonitorRtspController.templateURL,
                controller: Application.Controllers.MonitorRtspController.$name,
                inputs: {
                    blocksInfo: this.blocksInfo,
                    rtspUrl: rtspUrl,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.MonitorRtspController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    this.isMonitored();
                    modalElem.hide();
                });
            });
        }

        public showAudioVideoInfo(): boolean {
            return this.blocksInfo[1].lastParseTimeDiff !== 'no data'
              && this.isStreamingNow('sink')
              && this.blocksInfo[this.blocksInfo.length - 1].nodeType.name !== NetworkNodeType.VIRT_SRT_RX_CALL
              && this.blocksInfo[this.blocksInfo.length - 1].nodeType.name !== NetworkNodeType.VIRT_SRT_RX_LSTN;
        }

        public getSinkParam(param: string): string | number | boolean {
            if (this.sinkInfo) {
                let base: string = '';
                if (param === 'video') {                // In order to extract individual attributes of the sink's video 
                    let videoString: string = "";       // refer to getSinkVideoParam method
                    if (this.sinkInfo[base + "detectedFormat"]) {
                        videoString = "" + this.getSinkParam("detectedFormat");
                    }
                    if (this.sinkInfo[base + param + ".codec"]) {
                        videoString = videoString + " " + this.sinkInfo[base + param + ".codec"];
                    }
                    if (this.sinkInfo[base + param + ".pid"]) {
                        videoString = `${videoString} - PID ${this.sinkInfo[base + param + ".pid"]}`;
                    }
                    return videoString;
                } else if (param === 'srtUrlIp') {
                    if (this.sinkInfo[base + 'srtHost']) {
                        return this.sinkInfo[base + 'srtHost'];
                    } else {
                        let urlParams =  this.sinkInfo['srtUrl'].toString().split(":");
                        let ip = urlParams[1].substring(2);
                        return ip;
                    }
                } else if (param === 'srtUrlPort') {
                    if (this.sinkInfo[base + 'srtPort']) {
                        return this.sinkInfo[base + 'srtPort'];
                    } else {
                        return Utils.getUrlParam(this.sinkInfo["srtUrl"].toString(), "port");
                    }
                } else if (param === 'srtUrlPassphrase') {
                    if (this.sinkInfo[base + 'srtPassphrase']) {
                        return this.sinkInfo[base + 'srtPassphrase'];
                    } else {
                        return Utils.getUrlParam(this.sinkInfo["srtUrl"].toString(), "passphrase");
                    }
                } else if (param === 'srtUrlMode') {
                    if (this.sinkInfo[base + 'srtMode']) {
                        return this.sinkInfo[base + 'srtMode'];
                    } else {
                        return Utils.getUrlParam(this.sinkInfo["srtUrl"].toString(), "mode");
                    }
                } else {
                    return this.sinkInfo[base + param];
                }
            }
        }

        public getSinkVideoParam(param: string): string | number | boolean {
            if (this.sinkInfo) {
                let base: string = '';
                if (param === 'detectedFormat'){
                    return this.sinkInfo[base + 'detectedFormat'] ? this.sinkInfo[base + 'detectedFormat'] : '  ';
                }
                else if (param === 'codec' && this.sinkInfo[base + "video.codec"]) {
                    return this.sinkInfo[base + "video.codec"];
                } else if (param === 'pid' && this.sinkInfo[base + "video.pid"]) {
                    return `PID ${this.sinkInfo[base + "video.pid"]}`;
                } else {
                    return this.sinkInfo[base + param];
                }
            }
        }

        public getSinkVideoInfo(): string {
            if (!this.sinkInfo)
                return '';

            let codec: string = this.getSinkParam('video.codec') as string;
            if ((codec === undefined || codec === '') && this.encoderOptions !== undefined) {
                codec = this.encoderOptions.codec;
            }

            const bitrate: number = this.getSinkParam('configuredBitrate') as number;

            const delay: string = this.encoderOptions !== undefined ? this.encoderOptions.delay : undefined;

            const pid: string = this.getSinkParam('video.pid') as string;

            let videoInfo: string = '';
            videoInfo += !!codec ? codec : '';
            videoInfo += !!bitrate ? `, ${(bitrate / 1000000).toFixed(2)} Mbps` : '';
            videoInfo += !!delay ? `, ${delay}` : '';
            videoInfo += !!pid ? ` - PID ${pid}` : '';

            return videoInfo + '  ';
        }

        public getDestinationArraySize(): number {
            return this.getSourceParam('destinationDevice') ?
                (this.getSourceParam('destinationDevice') as string).split(',').length : 1;
        }

        public getDeviceStatusCode(isEncoder: boolean): number {
            let key: string = 'statusCode';
            if (isEncoder && this.sourceNodeInfo !== undefined) {
                return this.sourceNodeInfo[key] as number;
            } else if (!isEncoder && this.sinkNodeInfo !== undefined) {
                return this.sinkNodeInfo[key] as number;
            } else {
                return undefined;
            }
        }

        // TODO: avoid calling method from HTML
        public isDeviceStatusCodeValid(device: 'encoder' | 'decoder'): boolean {

            if (device === 'encoder' && (this.sourceInfo === undefined || Object.keys(this.sourceInfo).length === 0))
                return true;

            if (device === 'decoder' && (this.sinkInfo === undefined || Object.keys(this.sinkInfo).length === 0))
                return true;

            let code: number = this.getDeviceStatusCode(device === 'encoder');

            if (code === 403 || code === 401)
                return false;

            if (code === 500) {
                let last200: Date;
                if (device === 'encoder') {
                    last200 = this.blocksInfo[0].last200;
                } else {
                    last200 = this.blocksInfo[this.blocksInfo.length - 1].last200;
                }
                let now: Date = new Date();
                if (last200 === undefined) {
                    let sixtySecondsAgo: Date = new Date();
                    sixtySecondsAgo.setSeconds(sixtySecondsAgo.getSeconds() - 60);
                    last200 = sixtySecondsAgo;
                }
                let secsFromLast200: number = (now.getTime() - last200.getTime()) / 1000;
                if (secsFromLast200 < 60) {
                    // console.log('error 500 for the ' + device + ' but returning OK (' + secsFromLast200 + ' seconds from last 200)');
                    return true;
                } else {
                    // console.log('error 500 for the ' + device + ' and returning FAIL (' + secsFromLast200 + ' seconds from last 200)');
                    return false;
                }
            }

            if (code === 200) {
                if (device === 'encoder') {
                    this.blocksInfo[0].last200 = new Date();
                } else {
                    this.blocksInfo[this.blocksInfo.length - 1].last200 = new Date();
                }
            }

            return true;
        }

        public hasEmbeddedInterface(): boolean {
            if (this.blocksInfo && this.blocksInfo[0] && !!this.blocksInfo[0].guiUrl) {
                let type: Models.NetworkNodeType = this.blocksInfo[0].nodeType;
                return Utils.getMobileDevicesTypeNames().indexOf(type.name) > -1;
            }
            return false;
        }

        public isMvpDevice(type: Models.NetworkNodeType): boolean {
            return type.vendor === 'MVP';
        }

        public isSdiDestination(type: Models.NetworkNodeType): boolean {
            return type.name === 'SDI Destination';
        }

        public showDeviceWebInterface(node: IBlockInfo): boolean {
            if (node) {
                if (!node.adminUrl)
                    return false;

                return node.nodeType.name !== 'IKUSNET-QUAD';
            }
            return false;
        }

        public audioLevelUnavailable(audioLevel: number): boolean {
            return (isNaN(audioLevel) || audioLevel === undefined);
        }

        public audioLevelIsZero(): boolean {
            if (this.sourceAudios && this.sourceAudios.length > 0) {
                for (const sourceAudio of this.sourceAudios) {
                    if (sourceAudio.lLevel > 1 || sourceAudio.lLevelDB > -39) {
                        return false;
                    }
                }
            }
            if (this.sinkAudios && this.sinkAudios.length > 0)  {
                for (const sinkAudio of this.sinkAudios) {
                    if (sinkAudio.lLevel > 1 || sinkAudio.lLevelDB > -39) {
                        return false;
                    }
                }
            }
            return true;
        }

        public startAudioProbing(blockId: number): void {
            this.tsProbeService.activateAudioMonByBlockId(blockId).then((activated: boolean) => {
                if (activated) {
                    this.audioMonitoringEnabled = true;
                    Utils.stickyAlert("Sound probing activated for 30 seconds!", "info", 4);
                    let count: number = 0;
                    if (this.processAdminInterfacesInterval !== undefined) this.$interval.cancel(this.processAdminInterfacesInterval);
                    this.processAdminInterfacesInterval = this.$interval(() => {
                        count++;
                        this.processAdminInterfaces();
                        if (count >= 30) {
                            this.$interval.cancel(this.processAdminInterfacesInterval);
                            this.tsProbeService.disableAudioMonByBlockId(blockId);
                            this.audioMonitoringEnabled = false;
                            Utils.stickyAlert("Sound probing deactivated! " +
                                "Click again on 'Start sound probing' to activate it for another 30 secs", "warn", 8);
                            this.processAdminInterfacesInterval = this.$interval(() => {
                                if (this.skipRequests === 0) {
                                    this.processAdminInterfaces();
                                } else {
                                    this.skipRequests--;
                                }
                            }, StreamDetailsController.INTERFACE_PARSER_TIMER);
                        }
                    }, StreamDetailsController.AUDIO_PROBING_TIMER);
                } else {
                    Utils.stickyAlert("Sound probing could not be activated", "error", 4);
                }
            });
        }

        public updateAudioLevels(audioParams: DeviceParam[]): void {
            audioParams.forEach((audioParam: DeviceParam) => {
                if (audioParam.name.indexOf("[0]") > -1) {
                    if (audioParam.name.indexOf("lLevelDB") > -1) {
                        this.vuMeterAudio[0].lLevelDB = audioParam.lastValue as number;
                    } else if (audioParam.name.indexOf("rLevelDB") > -1) {
                        this.vuMeterAudio[0].rLevelDB = audioParam.lastValue as number;
                    } else if (audioParam.name.indexOf("lLevel") > -1) {
                        this.vuMeterAudio[0].lLevel = audioParam.lastValue as number;
                    } else {
                        this.vuMeterAudio[0].rLevel = audioParam.lastValue as number;
                    }
                } else {
                    if (audioParam.name.indexOf("lLevelDB") > -1) {
                        this.vuMeterAudio[1].lLevelDB = audioParam.lastValue as number;
                    } else if (audioParam.name.indexOf("rLevelDB") > -1) {
                        this.vuMeterAudio[1].rLevelDB = audioParam.lastValue as number;
                    } else if (audioParam.name.indexOf("lLevel") > -1) {
                        this.vuMeterAudio[1].lLevel = audioParam.lastValue as number;
                    } else {
                        this.vuMeterAudio[1].rLevel = audioParam.lastValue as number;
                    }
                }
            });
        }

        public stopAudioProbing(blockId: number): void {
            this.tsProbeService.disableAudioMonByBlockId(blockId).then((disabled: boolean) => {
                if (disabled) {
                    if (this.processAdminInterfacesInterval !== undefined) this.$interval.cancel(this.processAdminInterfacesInterval);
                    this.processAdminInterfacesInterval = this.$interval(() => {
                        if (this.skipRequests === 0) {
                            this.processAdminInterfaces();
                        } else {
                            this.skipRequests--;
                        }
                    }, StreamDetailsController.INTERFACE_PARSER_TIMER);
                    this.audioMonitoringEnabled = false;
                    Utils.stickyAlert("Sound probing deactivated! " +
                        "Click again on 'Start sound probing' to activate it for another 30 secs", "warn", 8);
                } else {
                    Utils.stickyAlert("Sound probing could not be disabled", "error", 4);
                }
            });
        }

        private getSourceAudioLevel(channel: number): number {
            if (this.sourceInfo) {
                if (this.sourceInfo['audioLevelChannel' + channel]) {
                    let audioLevel: number = this.sourceInfo['audioLevelChannel' + channel] as number;
                    return audioLevel;
                }
            }
            return undefined;
        }

        private initVariables(): void {
            this.maxSynthValues = 2;
            this.numSynthValues = 0;
            this.urlParameters = Utils.getUrlParameters(this.$window.location.href);

            this.userService.loadCurrentUser().then((user: Models.User) => {
                // show PipeViewer access button only for admin user
                this.userIsAdmin = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN';
                });

                this.aclService.canRead("io.epiclabs.flex.api.WebApplication", 4).then((can: boolean) => {
                    this.canReadSupport = can;
                });
            });

        }

        private initBindings(): void {
            // on destroy
            this.$scope.$on('$destroy', () => {
                if (this.timeDiffInterval !== undefined) this.$interval.cancel(this.timeDiffInterval);
                if (this.processAdminInterfacesInterval !== undefined) this.$interval.cancel(this.processAdminInterfacesInterval);
                if (this.streamTimer !== undefined) this.$interval.cancel(this.streamTimer);
                if (this.getDataTimer !== undefined) this.$interval.cancel(this.getDataTimer);
                if (this.trendingInfo) {
                    this.trendingInfo.close();
                    this.trendingInfo = undefined;
                }
                this.stompReconnectUnsubscribe();
            });

            this.stompReconnectUnsubscribe = this.$rootScope.$on('stompReconnect', () => {
                if (this.trendingInfo) {
                    this.trendingInfo.closeAfterReconection();
                    this.trendingInfo.initTrendingData();
                }
            });

        }

        /**
         * check if primary decoder block signal has redundancy, if so, get redundancy info
         * to show it in pipeviewer
         * @param sinkId Id of primary decoder block
         */
        private checkBlockRedundancy(sinkId: number){

            this.blockService.getRedundantBlocks(sinkId).then( (res: any)=> {
                if(res.secondaryDecoderBlock) {
                    this.showRedundantStream= true;
                    this.getRedundantStream(sinkId, res.secondaryDecoderBlock.id);
                }
            });
        }
        /**
         * temporary solution -  redirect to redundant stream when clicking on it's toolbar
         */
        private goToRedundantStream(){
            let url = "#!/stream/" + ((Number(this.streamId)) -1);
             this.$window.location.href = url;
            
        }

        /**
         * Getting the info necessary to display the redundant pipeviewer
         * @param sinkId Id of primary decoder block
         * @param redundantSinkId Id of redundant decoder block
         */
        private getRedundantStream(sinkId: number, redundantSinkId: number){
            this.streamPipeService.getStreamPipeByDestinationBlockIdPromise(redundantSinkId).then((res: any) => {
                this.streamRedundantId = res[0]._embedded.streamPipeBlockConnections[0].pipeStreamId;
                this.streamPipeService
                    .getStreamPipeBlockConnectionsByStreamId(this.streamRedundantId)
                    .then((res: Models.IStreamPipeBlockConnectionInfo[]) => {
                            let firstConnection: Models.IStreamPipeBlockConnectionInfo = res[0];
                            let lastConnection: Models.IStreamPipeBlockConnectionInfo = res[res.length - 1];
                            this.redundantBlocksInfo = [
                                {
                                    blockConnection: firstConnection,
                                    name: firstConnection.origBlockConnection ? firstConnection.origBlockConnection.blockName : undefined,
                                    firstParsedDatetime: 0,
                                    lastParsedDatetime: 0,
                                    lastParseTimeDiff: '',
                                    deviceUnreachable: false,
                                }, {
                                    blockConnection: lastConnection,
                                    name: lastConnection.destBlockConnection ? lastConnection.destBlockConnection.blockName : undefined,
                                    firstParsedDatetime: 0,
                                    lastParsedDatetime: 0,
                                    lastParseTimeDiff: '',
                                    deviceUnreachable: false,
                                }];
                    });
                
            })
        }

        private getStreamIdAndStreamBlocksInfo(): void {
            this.streamId = parseInt((this.$routeParams as { streamId: string; }).streamId, 10);
            if (this.streamId && this.streamId > 0) {
                this.loadStreamPipe();

                this.streamPipeService
                    .getStreamPipeBlockConnectionsByStreamId(this.streamId)
                    .then((res: Models.IStreamPipeBlockConnectionInfo[]) => {
                        if (res.length > 0) {
                            let firstConnection: Models.IStreamPipeBlockConnectionInfo = res[0];
                            let lastConnection: Models.IStreamPipeBlockConnectionInfo = res[res.length - 1];
                            this.blocksInfo = [
                                {
                                    blockConnection: firstConnection,
                                    name: firstConnection.origBlockConnection ? firstConnection.origBlockConnection.blockName : undefined,
                                    firstParsedDatetime: 0,
                                    lastParsedDatetime: 0,
                                    lastParseTimeDiff: '',
                                    deviceUnreachable: false,
                                }, {
                                    blockConnection: lastConnection,
                                    name: lastConnection.destBlockConnection ? lastConnection.destBlockConnection.blockName : undefined,
                                    firstParsedDatetime: 0,
                                    lastParsedDatetime: 0,
                                    lastParseTimeDiff: '',
                                    deviceUnreachable: false,
                                }];

                            this.loadNodeTypes();

                            // last update time
                            if (this.blocksInfo && this.blocksInfo.length > 1) {
                                this.blocksInfo[0].lastParseTimeDiff = this.getLastParseTimeDiff(0);
                                this.blocksInfo[this.blocksInfo.length - 1].lastParseTimeDiff = this.getLastParseTimeDiff(1);
                            }
                            if (this.timeDiffInterval !== undefined) this.$interval.cancel(this.timeDiffInterval);
                            this.timeDiffInterval = this.$interval(() => {
                                if (this.blocksInfo && this.blocksInfo.length > 1) {
                                    this.blocksInfo[0].lastParseTimeDiff = this.getLastParseTimeDiff(0);
                                    this.blocksInfo[this.blocksInfo.length - 1].lastParseTimeDiff = this.getLastParseTimeDiff(1);
                                }
                            }, StreamDetailsController.INTERFACE_PARSER_ELAPSED_TIMER);

                            // start parsing admin interfaces
                            this.processAdminInterfaces();

                            if (this.processAdminInterfacesInterval !== undefined)
                                this.$interval.cancel(this.processAdminInterfacesInterval);

                            this.processAdminInterfacesInterval = this.$interval(() => {
                                if (this.skipRequests === 0) {
                                    this.processAdminInterfaces();
                                } else {
                                    this.skipRequests--;
                                }
                            }, StreamDetailsController.INTERFACE_PARSER_TIMER);

                            // continue with the view generation (we need to be sure that it is a valid stream)
                            this.getStreamStatus();
                            if (this.streamTimer !== undefined) this.$interval.cancel(this.streamTimer);
                            this.streamTimer = this.$interval(() => {
                                this.getStreamStatus();
                                this.loadSourceProbeInfo();
                                this.loadSinkProbeInfo();
                            }, StreamDetailsController.STREAM_DATA_TIMER);

                            // let's go!
                            this.loadVideoFeed();
                            this.loadSourceProbeInfo();
                            this.loadSinkProbeInfo();
                            this.checkBlockRedundancy(lastConnection.destBlock.id);
                        } else {
                            this.streamId = undefined;
                        }


                        this.presetPathService.getPresetPathBlock(this.blocksInfo[0].blockConnection.origBlock.id.toString())
                            .then((data: string[]) => {
                            this.presetPathOriginValue = data.join('<br>');
                        });
                        this.presetPathService.getPresetPathBlock(this.blocksInfo[1].blockConnection.destBlock.id.toString())
                            .then((data: string[]) => {
                            this.presetPathDestinationValue = data.join('<br>');
                        });
                        this.isMonitored();
                    });
            }
          
        }

        private async loadSourceProbeInfo(): Promise<void> {
            let sourceBlockId: number = this.blocksInfo[0].blockConnection.origBlockId;
            this.isSourceTs = this.isSourceTsStream();
            this.sourceProbeInfo = await this.loadProbeInfo('source', sourceBlockId, this.sourceProbeInfo);
        }

        private async loadSinkProbeInfo(): Promise<void> {
            let sinkBlockId: number = this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlockId;
            this.isSinkTs = this.isSinkTsStream();
            this.sinkProbeInfo = await this.loadProbeInfo('sink', sinkBlockId, this.sinkProbeInfo);
        }

        private loadProbeInfo(type: 'source' | 'sink', blockId: number, probeInfo: ITSProbeInfo): ng.IPromise<ITSProbeInfo> {
            if (type === 'source' && this.isSourceTsStream() || type === 'sink' && this.isSinkTsStream()) {
                if (blockId) {
                    const blockName: string = type === 'source' 
                        ? this.blocksInfo[0].blockConnection.origBlock.name
                        : this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlock.name;
                    return this.tsProbeService.getConnectedProbeByBlockId(blockId).then((result: Models.IFindByTsResults) => {
                        const defaultTsProbe: Models.ITsProbeFound = result ? result.defaultTsProbe : undefined;
                        if (defaultTsProbe && result.selectedStream) {
                            probeInfo = {
                                blockId: blockId,
                                blockName: blockName,
                                hasAssignedProbe: true,
                                assignedProbe: defaultTsProbe.tsProbe,
                                assignedProbesFound: result,
                                lockingTSProbe: probeInfo ? probeInfo.lockingTSProbe : false,
                                hasLockedTSProbe: result.defaultTsProbe.locked,
                                slot: defaultTsProbe.slot,
                                style: {color: result.defaultTsProbe.locked ? 'green' : 'red'},
                            };
                            

                            this.aclService.getPermissions('networkNodes', defaultTsProbe.tsProbe.networkNodeId)
                                .then((evaluatedAcls: Models.IEvaluatedAcl) => {
                                    probeInfo.probePermissions = evaluatedAcls;
                                });

                            if (result.defaultTsProbe.locked) {
                                probeInfo.lockingTSProbe = false;
                                probeInfo.style = {color: 'green'};
                            } else if (probeInfo.lockingTSProbe === false) {
                                probeInfo.style = {color: 'red'};
                            }

                        } else {
                            probeInfo = {
                                blockId: blockId,
                                blockName: blockName,
                                hasAssignedProbe: false,
                                assignedProbe: undefined,
                                hasLockedTSProbe: false,
                                lockingTSProbe: false,
                            } as ITSProbeInfo;
                            probeInfo.style = {color: 'black'};
                        }
                        return probeInfo;
                    }).catch((err: ngCustom.IReason) => {
                        if (probeInfo && !probeInfo.hasLockedTSProbe) {
                            probeInfo = {
                                blockId: blockId,
                                blockName: blockName,
                                hasAssignedProbe: false,
                                assignedProbe: undefined,
                                hasLockedTSProbe: false,
                                lockingTSProbe: false,
                            } as ITSProbeInfo;
                            probeInfo.style = {color: 'black'};
                        }
                        return probeInfo;
                    });
                }
            }
        }

        private loadNodeTypes(): void {
            let srcNetworkNodeTypeId: string = this.blocksInfo[0].blockConnection.origBlock.networkNodeTypeHref;
            let dstNetworkNodeTypeId: string = this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlock.networkNodeTypeHref;

            this.networkNodeTypeService.findById(parseInt(srcNetworkNodeTypeId, 10)).then((type: Models.NetworkNodeType) => {
                this.blocksInfo[0].nodeType = type;
            });
            this.networkNodeTypeService.findById(parseInt(dstNetworkNodeTypeId, 10)).then((type: Models.NetworkNodeType) => {
                this.blocksInfo[this.blocksInfo.length - 1].nodeType = type;
            });
        }

        private async initTrending(): Promise<void> {
            this.streamPipe = await this.streamPipeService.getStreamPipe(this.streamId.toString(), false) as Models.IStreamPipe;
            let streamId = this.streamId;
            if (!this.getDataTimer) {
                this.startGetDataInterval();
            }
            if (this.streamId && !this.trendingInfo) {
                // check if the sink block is the secondary block of a DR5000 and in that case,
                // take the stream of the primary block to show the bitrate properly
                if(this.streamPipe !== undefined ) {
                    const sinkRedundantBlock: IBlock = await this.blockService.findById(this.streamPipe.sinkBlockId);
                    if (sinkRedundantBlock !== null && sinkRedundantBlock.config.isRedundant !== null && sinkRedundantBlock.config.isRedundant) {
                        const blocksInNode: IBlock[] = await this.blockService.blocksInNode(Number(sinkRedundantBlock.networkNodeHref));
                        const primarytBlockInNode: IBlock = blocksInNode.filter( (x: IBlock) => !x.config.isRedundant)[0];
                        const streamPipePrimary: IStreamPipe[] = await this.streamPipeService.getStreamPipeByDestinationBlockIdPromise(primarytBlockInNode.id);
                        streamId = Number(streamPipePrimary[0].href.split("/").pop());
                    }
                }
                const streamPipeHref: string = "streamPipe/" + streamId;
                this.initChartOptions();
                this.trendingInfo = new Models.TrendingInfo(
                    this.streamStatusService, this.flexCollectorService, this.$timeout, this.$q,
                    streamPipeHref, 180, true,
                    () => {
                        if (this.trendingInfo.lastBitrates[0]) {
                            const lastBitrate: number = this.trendingInfo.lastBitrates[0].bitrate;
                            this.currentBitrateMbps = this.bitsToMpbs(lastBitrate);
                        }
                    }, ["bitrate"]
                );
                this.trendingInfo.initTrendingData();
            }
        }

        private getLastParseTimeDiff(index: number): string {
            let lastParseTimeDiff: string;
            let elapsed: number = Math.floor((new Date().getTime() - this.blocksInfo[index].lastParsedDatetime) / 1000);
            if (this.blocksInfo[index].firstParsedDatetime !== this.blocksInfo[index].lastParsedDatetime) {
                this.blocksInfo[index].deviceUnreachable = false;
                if (elapsed < 25) {
                    if (elapsed < 2) {
                        $(`#last-parse-${index}`).css('background-color', 'rgba(74, 241, 74, .4)');
                        this.$timeout(() => {
                            $(`#last-parse-${index}`).css('background-color', 'rgba(255, 255, 255, .8)');
                        }, 2000);
                    }
                    lastParseTimeDiff = `updated just now`;
                    // } else if (elapsed <= 60) {
                    //     $(`#last-parse-${index}`).css('background-color', 'rgba(255, 255, 255, .8)');
                    //     lastParseTimeDiff = `updated less than a minute ago`;
                    // } else if (Math.floor(elapsed / 60) < 60) {
                    //     elapsed = Math.floor(elapsed / 60);
                    //     $(`#last-parse-${index}`).css('background-color', 'rgba(251, 226, 238, .8)');
                    //     lastParseTimeDiff = `updated ${elapsed} minute${elapsed !== 1 ? 's' : ''} ago`;
                    // } else {
                    //     $(`#last-parse-${index}`).css('background-color', 'rgba(251, 226, 238, .8)');
                    //     elapsed = Math.floor(elapsed / 3600);
                    //     lastParseTimeDiff = `updated ${elapsed} hour${elapsed !== 1 ? 's' : ''} ago`;
                    // }
                } else {
                    let streamStatusDesc: string = 'streamStatusDesc';
                    $(`#last-parse-${index}`).css('background-color', 'rgba(251, 226, 238, .8)');
                    lastParseTimeDiff = `no data`;
                    if (index === 0) {
                        this.sourceInfo[streamStatusDesc] = "no data";
                    } else if (index === 1) {
                        this.sinkInfo[streamStatusDesc] = "no data";
                    }
                }
            } else if (elapsed > 40) {
                this.blocksInfo[index].deviceUnreachable = true;
            }

            return lastParseTimeDiff;
        }

        private processAdminInterfaces(): void {
            if (this.blocksInfo) {
                if (this.blocksInfo[0].guiUrl) {
                    this.parseEncoderAdminInterface();
                } else {
                    this.getEncoderAdminInterfaceUrl().then(() => {
                        this.parseEncoderAdminInterface();
                    });
                }

                if (this.blocksInfo[this.blocksInfo.length - 1].adminUrl) {
                    this.parseReceiverAdminInterface();
                } else {
                    this.getReceiverAdminInterfaceUrl().then(() => {
                        this.parseReceiverAdminInterface();
                    });
                }
            }
        }

        private getEncoderAdminInterfaceUrl(): ng.IPromise<void> {
            const nodeId: number = Utils.idFromHref(this.blocksInfo[0].blockConnection.origBlock.networkNodeHref);
            return this.aclService.canAccessGui(nodeId).then((canAccess: boolean) => {
                if (canAccess) {
                    return this.deviceGuiService.getDeviceGuiByBlockId(this.blocksInfo[0].blockConnection.origBlockId.toString()).then(
                        (response: Models.DeviceGui) => {
                            if (response.proxyType !== "HOST_DISABLED") {
                                this.blocksInfo[0].adminUrl = this.$sce.trustAsResourceUrl(response.apiUrl);
                            }
                            if (response.guiUrl) {
                                this.blocksInfo[0].guiUrl = this.$sce.trustAsResourceUrl(response.guiUrl + "gui/");
                            }
                        });
                } else {
                    return;
                }
            });
        }

        private getReceiverAdminInterfaceUrl(): ng.IPromise<void> {
            const nodeId: number = Utils.idFromHref(this.blocksInfo[1].blockConnection.destBlock.networkNodeHref);
            return this.aclService.canAccessGui(nodeId).then((canAccess: boolean) => {
                if (canAccess) {
                    return this.deviceGuiService.getDeviceGuiByBlockId(this.blocksInfo[1].blockConnection.destBlockId.toString()).then(
                        (response: Models.DeviceGui) => {
                            if (response.proxyType !== "HOST_DISABLED") {
                                this.blocksInfo[1].adminUrl = this.$sce.trustAsResourceUrl(response.guiUrl);
                            }
                        });
                } else {
                    return;
                }
            });
        }

        private parseEncoderAdminInterface(): void {
            // let index: number = 0;
            let ioTypeId: string = StreamDetailsController.IO_NETWORK_NODE_TYPE_ID;
            this.blocksInfo[0].isIO = this.blocksInfo[0].blockConnection.origBlock.networkNodeTypeHref === ioTypeId;

            this.flexCollectorService
                .getDeviceParamsBySimplifiedHref('blocks/' + this.blocksInfo[0].blockConnection.origBlockId)
                .then((response: Models.DeviceParams) => {
                    this.blocksInfo[0].parsedInfo = response;
                    this.sourceInfo = response.getEncoderInfo();
                    this.sourceAudios = response.getAudioInfo(this.sourceInfo, this.encoderOptions);

                    if (this.getSourceParam('streamStatus') !== undefined) {
                        let [streamStatusParam]: DeviceParam[] = response.params.filter((param: DeviceParam) => {
                            return param.name === 'streamStatus';
                        });

                        if (streamStatusParam !== undefined) {
                            const frontTime: number = new Date().getTime();
                            this.blocksInfo[0].lastParsedDatetime = frontTime;
                        }
                    }
                    this.blocksInfo[0].lastParseTimeDiff = this.getLastParseTimeDiff(0);
                    this.vuMeterAudio = this.getVuMeterAudio();
                });

            this.flexCollectorService
                .getDeviceParamsBySimplifiedHref('networkNodes/' + this.blocksInfo[0].blockConnection.origBlock.networkNodeHref)
                .then((response: Models.DeviceParams) => {
                    this.sourceNodeInfo = response.getDigesterInfo();
                });
        }

        /**
         * This method calls the backend and gets the decoder block's device params. It then:
         * 1) Stores it in global variable blocksInfo and also:
         *   a) Stores lastParsedDateTime if it has streamStatus
         *   b) Stores lastParsedDateTimeDiff
         * 2) Stores it in global variable sinkInfo. For this is also formats srtUrl if it has it
         * 3) Stores the audio info in sinkAudios and vuMeterAudio
         */
        private async parseReceiverAdminInterface(): Promise<void> {
            let ioTypeId: string = StreamDetailsController.IO_NETWORK_NODE_TYPE_ID;
            this.blocksInfo[this.blocksInfo.length - 1].isIO =
                this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlock.networkNodeTypeHref === ioTypeId;
            let blockDestId: number = this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlockId;
            const sinkRedundantBlock: IBlock = await this.blockService.findById(this.streamPipe.sinkBlockId);
            if (sinkRedundantBlock !== null && sinkRedundantBlock.config.isRedundant !== null && sinkRedundantBlock.config.isRedundant) {
                const blocksInNode: IBlock[] = await this.blockService.blocksInNode(Number(sinkRedundantBlock.networkNodeHref));
                const primarytBlockInNode: IBlock = blocksInNode.filter( (x: IBlock) => !x.config.isRedundant)[0];
                this.streamPipeRedundant = await this.streamPipeService.getStreamPipeByDestinationBlockIdPromise(blockDestId);
                this.streamPipeSourceBlock = await this.blockService.findById(this.streamPipeRedundant[0].sourceBlockId);
                blockDestId = primarytBlockInNode.id;
            }
            this.flexCollectorService
                .getDeviceParamsBySimplifiedHref('blocks/' + blockDestId)
                .then((response: Models.DeviceParams) => {
                    this.blocksInfo[this.blocksInfo.length - 1].parsedInfo = response;
                    this.sinkInfo = response.getDigesterInfo();
                    this.sinkInfo['srtflexUrl'] = this.getSinkParam('srtUrl')
                        ? Utils.generateSrtURLWithFlexProtocol(this.getSinkParam('srtUrl') as string) : undefined;
                    this.sinkAudios = response.getAudioInfo(this.sinkInfo, undefined);
                    if (this.getSinkParam('streamStatus') !== undefined) {
                        let [streamStatusParam]: DeviceParam[] = response.params.filter((param: DeviceParam) => {
                            return param.name === 'streamStatus';
                        });
                        if (streamStatusParam !== undefined) {
                            const frontTime: number = new Date().getTime();
                            this.blocksInfo[this.blocksInfo.length - 1].lastParsedDatetime = frontTime;
                        }
                    }
                    if (this.getSinkParam('sourceDevice') !== undefined && blockDestId !== this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlockId) {
                        this.sinkInfo['sourceDevice'] = this.streamPipeSourceBlock.config.ts.ip + ":" + this.streamPipeSourceBlock.config.ts.port;
                    }
                    this.blocksInfo[this.blocksInfo.length - 1].lastParseTimeDiff = this.getLastParseTimeDiff(1);
                    this.vuMeterAudio = this.getVuMeterAudio();
                });

            this.flexCollectorService
                .getDeviceParamsBySimplifiedHref('networkNodes/' + this.blocksInfo[this.blocksInfo.length - 1].blockConnection.destBlock.networkNodeHref)
                .then((response: Models.DeviceParams) => {
                    this.sinkNodeInfo = response.getDigesterInfo();
                });
        }

        private getStreamStatus(): void {
            if (this.streamId !== undefined) {
                this.streamStatusService
                    .getStreamStatus(this.streamId.toString())
                    .then((dataStatus: Models.IStreamStatus) => {
                        this.dataStatus = dataStatus;
                        this.mapVerboseToValues();
                        this.convertEncoderOptionsToObject();
                    })
                    .catch((reason: ngCustom.IReason) => {
                        this.$location.path('/multiviewer');
                    });
            }
        }

        private convertEncoderOptionsToObject(): void {
            if (!this.dataStatus || !this.dataStatus.status || !this.dataStatus.status.imaliveplusplus ||
                !this.dataStatus.status.imaliveplusplus.data) {

                return;
            }

            this.encoderOptions = {
                encoderInput: undefined,
                audioInput: undefined,
                encoderOutput: undefined,
                delay: undefined,
                codec: undefined,
            };

            let input: Models.IStreamAliveData;
            [input] = this.dataStatus.status.imaliveplusplus.data.filter((option: Models.IStreamAliveData) => option.name === 'input');

            let videoconnector: Models.IStreamAliveData;
            [videoconnector] = this.dataStatus.status.imaliveplusplus.data
                .filter((option: Models.IStreamAliveData) => option.name === 'videoconnector');
            if (videoconnector !== undefined && videoconnector.options[videoconnector.selected] !== undefined) {
                if (this.encoderOptions.encoderInput) {
                    this.encoderOptions.encoderInput += videoconnector.options[videoconnector.selected];
                } else {
                    this.encoderOptions.encoderInput = videoconnector.options[videoconnector.selected];
                }
            }

            let audioconnector: Models.IStreamAliveData;
            [audioconnector] = this.dataStatus.status.imaliveplusplus.data.filter((option: Models.IStreamAliveData) => {
                return option.name === 'audioconnector';
            });
            this.encoderOptions.audioInput = (audioconnector !== undefined) ? audioconnector.options[audioconnector.selected] : undefined;

            let output: Models.IStreamAliveData;
            [output] = this.dataStatus.status.imaliveplusplus.data.filter((option: Models.IStreamAliveData) => {
                return option.name === 'output';
            });
            this.encoderOptions.encoderOutput = (output !== undefined) ? output.options[output.selected] : undefined;

            let delay: Models.IStreamAliveData;
            [delay] = this.dataStatus.status.imaliveplusplus.data.filter((option: Models.IStreamAliveData) => {
                return option.name === 'delay';
            });
            this.encoderOptions.delay = (delay !== undefined) ? delay.options[delay.selected] : undefined;

            let vCodec: Models.IStreamAliveData;
            [vCodec] = this.dataStatus.status.imaliveplusplus.data.filter((option: Models.IStreamAliveData) => {
                return option.name === 'videocodec';
            });
            let aCodec: Models.IStreamAliveData;
            [aCodec] = this.dataStatus.status.imaliveplusplus.data.filter((option: Models.IStreamAliveData) => {
                return option.name === 'audiocodec';
            });
            if (vCodec !== undefined || aCodec !== undefined) {
                this.encoderOptions.codec = (vCodec !== undefined) ? vCodec.options[vCodec.selected] : 'H264';
                this.encoderOptions.audioCodec = (aCodec !== undefined) ? aCodec.options[aCodec.selected] : '';
            }
        }

        private loadVideoFeed(): void {
            this.connectionRoomService.getVideoFeedPromiseByStreamPipeId(this.streamId.toString()).then(
                (videoFeed: Models.VideoFeed) => {
                    if (videoFeed.status !== Models.VideoFeedStatus.ERROR) {
                        this.streamExists = true;
                        if (!videoFeed.equals(this.videoFeed)) {
                            this.videoFeed = videoFeed;
                            this.streamURL = videoFeed.videoUrl;
                        }
                    } else {
                        this.streamExists = false;
                    }
                }
            ).catch(
                () => {
                    this.streamExists = false;
                }
            );
        }

        private startGetDataInterval(): void {
            if (this.getDataTimer !== undefined) {
                this.$interval.cancel(this.getDataTimer);
            }

            this.getDataTimer = this.$interval(() => {
                this.getTrendingData();
            }, StreamDetailsController.STREAM_DATA_TIMER);
        }

        private mapVerboseToValues(): void {
            let delayValueOptions: IMapStreamAliveDataOptions = {
                'delay_ultralow': {
                    label: '0.8 seconds',
                    value: 0.8,
                },
                'delay_verylow': {
                    label: '1.8 seconds',
                    value: 1.8,
                },
                'delay_low': {
                    label: '2.8 seconds',
                    value: 2.8,
                },
                'delay_medium': {
                    label: '5 seconds',
                    value: 5,
                },
                'delay_high': {
                    label: '10 seconds',
                    value: 10,
                },
                'delay_veryhigh': {
                    label: '20 seconds',
                    value: 20,
                },
            };

            let outputValueOptions: IMapStreamAliveDataOptions = {
                'output_low': {
                    label: '1 Mbps',
                    value: 1,
                },
                'output_medium': {
                    label: '2 Mbps',
                    value: 2,
                },
                'output_high': {
                    label: '4 Mbps',
                    value: 4,
                },
            };

            if (this.dataStatus.status && this.dataStatus.status.imaliveplusplus && this.dataStatus.status.imaliveplusplus.data) {
                for (let option of this.dataStatus.status.imaliveplusplus.data) {
                    if (option.name === 'delay' && option.selected !== 'delay_custom') {
                        let delayOptionsArray: IMapedStreamAliveDataOption[] = Object.keys(option.options)
                            .map((key: string) => {
                                if (delayValueOptions[key]) {
                                    return {
                                        key: key,
                                        label: delayValueOptions[key].label,
                                        value: delayValueOptions[key].value,
                                    };
                                } else {
                                    return {
                                        key: key,
                                        label: option.options[key],
                                        value: 9999,
                                    };
                                }
                            })
                            .sort((obj1: { value: number }, obj2: { value: number }) => {
                                return obj1.value - obj2.value;
                            });
                        option.options = {};
                        delayOptionsArray.forEach((delayOption: IMapedStreamAliveDataOption) => {
                            option.options[delayOption.key] = delayOption.label;
                        });
                    } else if (option.name === 'output' && option.selected !== 'delay_custom') {
                        let outputOptionsArray: IMapedStreamAliveDataOption[] = Object.keys(option.options)
                            .map((key: string) => {
                                if (outputValueOptions[key]) {
                                    return { key: key, label: outputValueOptions[key].label, value: outputValueOptions[key].value };
                                } else {
                                    return { key: key, label: option.options[key], value: 9999 };
                                }
                            })
                            .sort((obj1: { value: number }, obj2: { value: number }) => {
                                return obj1.value - obj2.value;
                            });
                        option.options = {};
                        outputOptionsArray.forEach((outputOption: IMapedStreamAliveDataOption) => {
                            option.options[outputOption.key] = outputOption.label;
                        });
                    }
                }
            }
        }

        /**
         * Update the graph with data from a new call to the service
         */
        private getTrendingData(): void {
            if (!this.trendingInfo) {
                this.initTrending();
            }
        }

        private loadStreamPipe(): void {
            this.streamPipeService
                .getStreamPipe(this.streamId.toString())
                .then((status: Models.IStreamPipe) => {
                    this.streamPipe = status;
                }).catch(() => {
                    this.$location.path('/multiviewer');
                });
        }

        private bitsToMpbs(bits: number): number {
            if (bits === null) // tslint:disable-line
                return null; // tslint:disable-line
            let value: number = parseFloat((bits / 1000000).toFixed(2));
            return isNaN(value) ? 0 : value;
        }

        private isSourceTsStream(): boolean {
            const block: IBlockInfo = this.blocksInfo ? this.blocksInfo[0] : undefined;
            return block && block.blockConnection &&
                block.blockConnection.origBlockConnection.connectionTypeName === "TSoIP" &&
                this.isSourceMulticast(block.blockConnection);
        }

        private isSinkTsStream(): boolean {
            const block: IBlockInfo = this.blocksInfo ? this.blocksInfo[this.blocksInfo.length - 1] : undefined;
            return block && block.blockConnection &&
                block.blockConnection.destBlockConnection.connectionTypeName === "TSoIP" &&
                this.isSinkMulticast(block.blockConnection);
        }

        private getVuMeterAudio(): Models.FullAudioInfo[] {
            if (this.sinkAudios && this.sinkAudios.length && !isNaN(this.sinkAudios[0].lLevel)) {
                return this.sinkAudios;
            } else {
                return this.sourceAudios;
            }
        }

        private isSourceMulticast(blockConnection: Models.IStreamPipeBlockConnectionInfo): boolean {
            return typeof blockConnection.origBlock.config.ts !== 'undefined' &&
                   typeof blockConnection.origBlock.config.ts.ip !== 'undefined' ?
                   Common.IpUtils.ipIsMulticast(blockConnection.origBlock.config.ts.ip) : false;
        }

        private isSinkMulticast(blockConnection: Models.IStreamPipeBlockConnectionInfo): boolean {
            return blockConnection.destBlock.networkNodeTypeHref === "" + Models.VTD_NETWORK_NODE_TYPE ||
                (typeof blockConnection.destBlock.config.ts !== 'undefined' &&
                   typeof blockConnection.destBlock.config.ts.ip !== 'undefined' ?
                   Common.IpUtils.ipIsMulticast(blockConnection.destBlock.config.ts.ip) : false);
        }

        public getGraphStyle = (): Object => {
            return {
                // 'top': `-100px`,
                'height': `50%`,
            };
        };

        private initChartOptions(): void {

        }

        /**
         * Execute and show MVP Data Table if condition is applied
         * @param blockIndex index of block in BlocksInfo array
         * @param networkTypeArray 7: Flex_Agile,
         */
        public showIfHaveRightDevice(blockIndex:number, networkTypeArray: any) {
                if(this.blocksInfo === undefined || this.blocksInfo[blockIndex].nodeType === undefined) return false;
                return this.blocksInfo[blockIndex].nodeType.vendor === 'MVP' && networkTypeArray.includes(this.blocksInfo[blockIndex].nodeType.id);
        }

        public async isMonitored(){
            const srtMonitoredId: number = this.blocksInfo[this.blocksInfo.length - 1].blockConnection.origBlock.id;
            const monitorNodes: any = await this.networkNodeService.getMonitorNodes();
            const monitorBlocks = await this.blockService.getMonitorBlocks(monitorNodes);
            this.isAlreadyMonitored = monitorBlocks.some( (block: IBlock)=>{
                if(block.config.monitoring){
                    return block.config.monitoring == srtMonitoredId;
                }else{
                    return false;
                }                
            } );
        }

        public openGrafanaChart(url: string){
            this.$window.open(url, '_blank');
        }

    }

}
